<ng-content select="top"></ng-content>
<app-loading *ngIf="loading" [fullHeight]="true"></app-loading>
<div *ngIf="!loading" class="c-group">
  <div class="l-has-btn">
    <div class="c-name" id="name">
      <div class="c-name__main">
        <a
          class="c-name__select"
          (click)="clickAllArrowButton()"
          style="cursor: pointer"
        >
          <h2 class="c-texts--head2">
            {{ arrowAllOpen ? "全て格納する" : "全て展開する" }}
          </h2>
        </a>
      </div>
      <span>取引先コード：</span>
      <div class="c-name__main">
        <a
          class="c-name__select"
          (click)="showDivisionPanel = true"
          (clickOutside)="showDivisionPanel = false"
          style="cursor: pointer"
        >
          <h2 class="c-texts--head2">{{ selectDivisionName }}</h2>
          <span class="c-name__arrow"
            ><i class="c-icon__arrow_s_bottom"></i></span
        ></a>
        <div class="c-name__namelist" [class.is-show]="showDivisionPanel">
          <ul style="display: block">
            <li (click)="changeDivision('')" style="cursor: pointer">
              <a>全て</a>
            </li>
            <li
              *ngFor="let division of serviceDivisions"
              (click)="changeDivision(division)"
              style="cursor: pointer"
            >
              <a>{{ division }}</a>
            </li>
            <li
              *ngIf="backConnectedMoreMap?.length"
              (click)="changeDivision('connectedMore')"
              style="cursor: pointer"
            >
              <a>ランチャー系</a>
            </li>
            <li
              *ngIf="backUnconectedMap?.length"
              (click)="changeDivision('unconnected')"
              style="cursor: pointer"
            >
              <a>未接続</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="c-group__wrap">
    <ng-container *ngFor="let service1 of dispServiceMap">
      <div class="arrow">
        <span
          class="c-nav__arrow"
          [class.is-open]="!service1.childHidden"
          (click)="service1.childHidden = !service1.childHidden"
          ><i class="c-icon__arrow_s_bottom"></i
        ></span>
      </div>
      <div class="c-group__block">
        <div class="c-group__body">
          <!-- 一階層目 -->
          <div class="c-group__parent">
            <app-service-map-block
              [attr.data-square-actuate-id]="service1.actuateId"
              [service]="service1"
              (clickService)="clickServiceEvent(service1, null, 1)"
              (clickIcon)="clickIconEvent(service1, null, 1)"
            ></app-service-map-block>
          </div>
          <!-- 二階層目 -->
          <div
            *ngIf="!service1.childHidden && service1.children?.length"
            class="c-group__children"
          >
            <ng-container *ngFor="let service2 of service1.children">
              <div class="c-group__line">
                <app-service-map-block
                  [attr.data-square-actuate-id]="service2.forceCircleMode ? null : service2.actuateId"
                  [service]="service2"
                  [circleMode]="service2.forceCircleMode"
                  (clickService)="clickServiceEvent(service2, service1, 2, service2.forceCircleMode)"
                  (clickIcon)="clickIconEvent(service2, service1, 2)"
                >
                </app-service-map-block>
                <app-service-map-block
                  *ngIf="!service2.forceCircleMode && connectedOtherServiceByActuateCd[service2.actuateId] as otherService"
                  [service]="otherService"
                  [circleMode]="true"
                  togglePosition="left"
                  (clickService)="clickServiceEvent(otherService, service2, 3, true)"
                  (clickIcon)="clickIconEvent(otherService, service2, 3)"
                ></app-service-map-block>
                <ng-container *ngIf="!service2.forceCircleMode && !connectedOtherServiceByActuateCd[service2.actuateId]">
                  <!-- 3階層目 -->
                  <div
                    class="c-group__body"
                    *ngFor="let service3 of service2.children"
                  >
                    <app-service-map-block
                      [attr.data-square-actuate-id]="service3.forceCircleMode ? null : service3.actuateId"
                      [service]="service3"
                      [circleMode]="service3.forceCircleMode"
                      togglePosition="left"
                      (clickService)="clickServiceEvent(service3, service2, 3, service3.forceCircleMode)"
                      (clickIcon)="clickIconEvent(service3, service2, 3)"
                    ></app-service-map-block>
                    <!-- 4階層目 -->
                    <div
                      *ngIf="!service3.forceCircleMode && service3.children.length"
                      class="c-group__children"
                    >
                      <ng-container *ngFor="let service4 of service3.children">
                        <div class="c-group__line">
                          <app-service-map-block
                            [attr.data-square-actuate-id]="service4.forceCircleMode ? null : service4.actuateId"
                            [service]="service4"
                            [circleMode]="service4.forceCircleMode"
                            togglePosition="left"
                            (clickService)="
                              clickServiceEvent(service4, service3, 4, service4.forceCircleMode)
                            "
                            (clickIcon)="clickIconEvent(service4, service3, 4)"
                          ></app-service-map-block>
                          <app-service-map-block
                            *ngIf="!service4.forceCircleMode && connectedChildByActuateCd[service4.actuateId] as child"
                            [service]="child"
                            [circleMode]="true"
                            togglePosition="left"
                            (clickService)="clickServiceEvent(child, service4, 5, true)"
                            (clickIcon)="clickIconEvent(child, service4, 5)"
                          ></app-service-map-block>
                        </div>
                      </ng-container>

                      <!-- 4階層目アクションブロック ∟　にしたい　-->
                      <ng-container
                        *ngTemplateOutlet="
                          actionBlockList;
                          context: {
                            actionBlocks: service3.actionBlocks,
                            parentBlock: service3,
                            floorNumber: 4,
                            wrapperClass: 'c-group__line'
                          }
                        "
                      ></ng-container>
                    </div>
                  </div>
                  <!-- 3階層目アクションブロック -->
                  <ng-container
                    *ngTemplateOutlet="
                      actionBlockList;
                      context: {
                        actionBlocks: service2.actionBlocks,
                        parentBlock: service2,
                        floorNumber: 3,
                        wrapperClass: 'c-group__body'
                      }
                    "
                  ></ng-container>
                </ng-container>
              </div>
            </ng-container>
            <!-- 2階層目アクションブロック　-->
            <ng-container
              *ngTemplateOutlet="
                actionBlockList;
                context: {
                  actionBlocks: service1.actionBlocks,
                  parentBlock: service1,
                  floorNumber: 2,
                  wrapperClass: 'c-group__line'
                }
              "
            ></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let sideArea of sideAreas">
      <ng-container *ngIf="sideArea.items.length">
        <div class="arrow">
          <span
            class="c-nav__arrow"
            [class.is-open]="sideArea.open"
            (click)="toggleSideArea(sideArea.key)"
            ><i class="c-icon__arrow_s_bottom"></i
          ></span>
        </div>
        <div class="c-group__block">
          <div class="c-group__body">
            <!-- 一階層目 -->
            <div class="c-group__parent">
              <div class="c-group__panel c-group__panel--default">
                <a class="c-panel c-panel--s no-click" style="cursor: pointer">
                  <p class="c-texts--s">
                    <b class="product-name">{{ sideArea.label }}</b>
                  </p></a
                >
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="sideArea.open">
          <ng-container *ngFor="let service1 of sideArea.items">
            <div class="c-group__block" style="margin-left: 623px">
              <div class="c-group__body">
                <!-- 一階層目 -->
                <div class="c-group__parent">
                  <app-service-map-block
                    [attr.data-square-actuate-id]="service1.actuateId"
                    [service]="service1"
                    togglePosition="left"
                    (clickService)="clickServiceEvent(service1, null, 1)"
                    (clickIcon)="clickIconEvent(service1, null, 1)"
                  ></app-service-map-block>
                </div>
                <!-- 二階層目 -->
                <div
                  *ngIf="!service1.childHidden && service1.children?.length"
                  class="c-group__children"
                >
                  <ng-container *ngFor="let service2 of service1.children">
                    <div class="c-group__line">
                      <app-service-map-block
                        [attr.data-square-actuate-id]="service2.forceCircleMode ? null : service2.actuateId"
                        [service]="service2"
                        [circleMode]="service2.forceCircleMode"
                        togglePosition="left"
                        (clickService)="clickServiceEvent(service2, service1, 2, service2.forceCircleMode)"
                        (clickIcon)="clickIconEvent(service2, service1, 2)"
                      ></app-service-map-block>
                      <app-service-map-block
                        *ngIf="sideArea.showCircle && !service2.forceCircleMode && connectedChildByActuateCd[service2.actuateId] as child"
                        [service]="child"
                        [circleMode]="true"
                        togglePosition="left"
                      ></app-service-map-block>
                    </div>
                  </ng-container>
                  <!-- 2階層目アクションブロック　-->
                  <ng-container
                    *ngTemplateOutlet="
                      actionBlockList;
                      context: {
                        actionBlocks: service1.actionBlocks,
                        parentBlock: service1,
                        floorNumber: 2,
                        wrapperClass: 'c-group__line'
                      }
                    "
                  ></ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template
      #actionBlockList
      let-actionBlocks="actionBlocks"
      let-parentBlock="parentBlock"
      let-floorNumber="floorNumber"
      let-wrapperClass="wrapperClass"
    >
      <ng-container *ngFor="let actionBlock of actionBlocks">
        <div [ngClass]="wrapperClass">
          <app-service-map-action-block
            [block]="actionBlock"
            (clickBlock)="clickActionBlockEvent(actionBlock, parentBlock, floorNumber)"
          ></app-service-map-action-block>
        </div>
      </ng-container>
    </ng-template>
    <div style="width: 280px">
      <ng-content select="bottom"></ng-content>
    </div>
  </div>
</div>
